export default __webpack_public_path__ + "static/media/pin-marker.abf0fdd5.png";